import React, {useEffect, useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {getFileList} from '../../../../OrderDetails/_redux/actions/OrderFilesActions';
import {FileList} from './FileList/FileList';
import Spinner from '../../../../_common/components/Spinner';
import {RootState} from '../../../../../../redux/store';

interface OrderFilesListProps {
  fileTypeID: number,
  orderID: number,
  shumaID: number,
  closePopup: () => void,
}

export const OrderFilesList = ({
                                 fileTypeID,
                                 orderID,
                                 shumaID,
                                 closePopup
                               }: OrderFilesListProps) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      setLoading(true);
      dispatch(getFileList(orderID));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);
  const orderFileList = useSelector(
    // @ts-ignore
    (state: RootState) => state.orderFilesReducer.orderFileList,
    shallowEqual
  );

  return loading ? <Spinner/> : (
    <FileList
      gotFiles={orderFileList.length > 0}
      fileList={orderFileList}
      orderID={orderID}
      shumaID={shumaID}
      fileTypeID={fileTypeID}
      showFileTypeColumn={false}
      allowDownloadFile={false}
      allowDeleteFile={false}
      allowSelectFile={true}
      closePopup={closePopup}
    />
  );
};
